// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"bc8a8bf7","192":"e33ff555","326":"3c2de5d5","389":"95ac3443","397":"1600219a","456":"c4cf0d11","465":"26eb62ed","706":"3c0a55fe","760":"ad804cca","863":"6e65485a","967":"5950a550"}[chunkId] + ".chunk.js";
};